import { Endpoint } from '../endpoint';
import { SummaryGraphResponse, SummaryResponse } from '@business/entities/summary';

export function fetchGraphGroupsSummary(params?: SummaryResponse) {
  return Endpoint.get<SummaryGraphResponse[]>(`@makh/summary/fetch-summary-graphs`, { params });
}

export function fetchGroupGraphs(data: SummaryResponse) {
  return Endpoint.post<SummaryGraphResponse[]>(`@makh/summary/summary-graphs`, { data });
}

export function updateGraphSummaryValues(data: SummaryResponse) {
  return Endpoint.post<SummaryGraphResponse>(`@makh/summary/add-summary-graphs`, { data });
}

export function updateSpreadsheetValues(data: any) {
  return Endpoint.post<SummaryGraphResponse>(`@makh/summary/add-spreadsheet-graphs`, { data });
}
